var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDegreeCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 20C69.7125 20 69.18 20 46.7463 24.4838C44.7325 23.1825 42.4225 22.5 40 22.5C37.5775 22.5 35.2675 23.1825 33.2537 24.4838C10.8125 20 10.305 20 10 20C4.3925 20 0 26.5888 0 35C0 43.4113 4.3925 50 10 50C10.3013 50 10.7987 50 32.5 45.6675V57.5C32.5 58.3663 32.9487 59.1713 33.6862 59.6263C34.4225 60.0825 35.3438 60.1238 36.1188 59.7363L40 57.795L43.8812 59.7363C44.235 59.9125 44.6175 60 45 60C45.4575 60 45.9125 59.875 46.3137 59.6263C47.0512 59.1713 47.5 58.3663 47.5 57.5V45.6675C69.2012 50 69.6988 50 70 50C75.6075 50 80 43.4113 80 35C80 26.5888 75.6075 20 70 20Z",
    fill: "url(#paint0_linear_1073_582)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22.5C33.1075 22.5 27.5 28.1075 27.5 35C27.5 41.8925 33.1075 47.5 40 47.5C46.8925 47.5 52.5 41.8925 52.5 35C52.5 28.1075 46.8925 22.5 40 22.5Z",
    fill: "url(#paint1_linear_1073_582)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 20C64.3925 20 60 26.5887 60 35C60 43.4113 64.3925 50 70 50C75.6075 50 80 43.4113 80 35C80 26.5887 75.6075 20 70 20Z",
    fill: "url(#paint2_linear_1073_582)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 50C68.62 50 67.5 48.88 67.5 47.5V35C67.5 33.62 68.62 32.5 70 32.5C71.38 32.5 72.5 33.62 72.5 35V47.5C72.5 48.88 71.38 50 70 50Z",
    fill: "url(#paint3_linear_1073_582)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 47.5C37.185 47.5 34.5925 46.5525 32.5 44.9762V57.5C32.5 58.3663 32.9487 59.1713 33.6862 59.6263C34.4225 60.0825 35.3438 60.1238 36.1188 59.7363L40 57.795L43.8812 59.7363C44.235 59.9125 44.6175 60 45 60C45.4575 60 45.9125 59.875 46.3137 59.6263C47.0512 59.1713 47.5 58.3663 47.5 57.5V44.9762C45.4075 46.5525 42.815 47.5 40 47.5Z",
    fill: "url(#paint4_linear_1073_582)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40C42.7614 40 45 37.7614 45 35C45 32.2386 42.7614 30 40 30C37.2386 30 35 32.2386 35 35C35 37.7614 37.2386 40 40 40Z",
    fill: "url(#paint5_linear_1073_582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1073_582",
    x1: 15.95,
    y1: 59.05,
    x2: 64.05,
    y2: 10.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1073_582",
    x1: 31.165,
    y1: 43.835,
    x2: 48.835,
    y2: 26.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1073_582",
    x1: 60.9513,
    y1: 44.0513,
    x2: 79.0513,
    y2: 25.9513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1073_582",
    x1: 65.1075,
    y1: 46.1437,
    x2: 74.8938,
    y2: 36.3575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1073_582",
    x1: 32.8613,
    y1: 58.8975,
    x2: 47.14,
    y2: 44.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD877"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1073_582",
    x1: 36.465,
    y1: 38.5362,
    x2: 43.5362,
    y2: 31.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD877"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegreeCertificate);
export default __webpack_public_path__ + "static/media/degree-certificate.b8ef6795670622d5e7ffa1ddf4f7fbde.svg";
export { ForwardRef as ReactComponent };